import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './features/auth/services/auth.service';
import { ToastComponent } from './shared/ui/toast/toast.component';
import { GlobalLoadingComponent } from './shared/ui/global-loading/global-loading.component';
import { StorageNoticeComponent } from './shared/ui/storage-notice/storage-notice.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastComponent, GlobalLoadingComponent, StorageNoticeComponent],
  template: `
    @if (isAuthInitializing()) {
      <div class="flex min-h-screen items-center justify-center px-6 text-center text-sm text-[var(--app-text-muted)]">
        Restoring your session...
      </div>
    } @else {
      <router-outlet />
    }
    <app-toast />
    <app-global-loading />
    <!-- Informative notice about the session cookie and the browser storage. It
         shows once per browser, on public and authenticated routes alike, because
         both use that storage. -->
    <app-storage-notice />
  `,
  styleUrl: './app.scss'
})
export class App {
  private readonly authService = inject(AuthService);

  protected readonly isAuthInitializing = this.authService.isAuthInitializing;
}

